// extracted by mini-css-extract-plugin
module.exports = {"__card":"card___card__1Niln"};